import { waitForBootstrap } from "./bootstrap-helpers";

(function () {

    function init() {        

        const Collapse = window.bootstrap.Collapse;

        $('.collapse-all').on('click', function () {
            const controlledElement = $(this).data('controls');
            const $controlledElement = $(controlledElement);

            const collapsedItems = $controlledElement.find('.collapse:not(.show)');

            if (collapsedItems.length > 0) {
                collapsedItems.each(function () {
                    Collapse.getOrCreateInstance(this).show();
                });

                $(this).text('Collapse All');
            } else {
                const openItems = $controlledElement.find('.collapse.show');

                openItems.each(function () {
                    Collapse.getOrCreateInstance(this).hide();
                });

                $(this).text('Expand All');
            }
        });

        $('[data-bs-toggle="collapse"], [data-toggle="collapse"]').on('click', function () {
            const $accordion = $(this).closest('.port-accordion');
            const accordionId = $accordion.attr('id');

            if (!accordionId) return;

            const isCurrentlyOpen = !$(this).hasClass('collapsed');
            const $expandButton = $(`[data-controls="#${accordionId}"]`);
            const collapsedItems = $accordion.find('.collapse:not(.show)');

            if (collapsedItems.length === 1 && !isCurrentlyOpen) {
                $expandButton.text('Collapse All');
            } else {
                $expandButton.text('Expand All');
            }
        });
    }

    //$(document).ready(init);
    waitForBootstrap(init);

})();